import React, {useState, useEffect} from "react";
import {Link, useLocation, useNavigate, useParams} from "react-router-dom";
import {Slider, Form, InputNumber, Radio, Switch, Checkbox, Col, Select, Row} from "antd";
import type {RadioChangeEvent} from "antd";
import axios from "axios";
import {ToastContainer, toast} from "react-toastify";
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";


import Collapse from "react-bootstrap/Collapse";
import "antd/dist/reset.css";
import "./filter.scss";


import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

import FilterStepsGems from "../parts/filter-steps-gems";
import ProductItem from "../parts/product_grid";
import ProductItemList from "../parts/product_list";
import CompareProductList from "../parts/compare-list";
import RecentProducts from "../parts/recently-products";
import {
    FaThList,
    FaTh,
    FaGem,
    FaMicroscope,
    FaSearchPlus,
    FaRegHeart,
    FaHeart,
    FaTimes,
    FaGripLines,
    FaRedoAlt
} from "react-icons/fa";
import ReactPaginate from "react-paginate";

function GemstoneSetting(props) {
    const navigate = useNavigate();
    const ucfirst = (str) => {
        if (typeof str !== 'string' || !str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1);
    };


    //Diamond Type
    const [isDiamondType, setDiamondType] = useState("gems");

    //Shapes
    const [isShape, setShape] = useState("");
    const [isShapeClicked, setShapeClicked] = useState(false);

    const [all_shape, setAll_shape] = useState([]);
    // const [showAllShape, setShowAllShape] = useState(false);

    // const visibleShapes = showAllShape ? all_shape : all_shape.slice(0, 7);

    //Cut

    const [isType, setType] = useState([]);
    const [isTreatment, setTreatment] = useState([]);
    const [isClarity, setClarity] = useState([]);
    const [isOrigin, setOrigin] = useState([]);
    const [isColor, setColor] = useState([]);
    const [isColorType, setColorType] = useState(2);
    const [isLab, setLab] = useState([]);

    const [ColorsMarks, setColorsMarks] = useState([]);

    const [TypeMarks, setTypeMarks] = useState([]);
    const [TreatmentMarks, setTreatmentMarks] = useState([]);
    const [OriginMarks, setOriginMarks] = useState([]);
    const [ClarityMarks, setClarityMarks] = useState([]);
    const [LabMarks, setLabMarks] = useState([]);


    const gemsSettings = async () => {
        try {
            const gemsSettingData = new FormData();
            gemsSettingData.append("request", JSON.stringify({
                action: "gems_settings",
            }));

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/setting`, {
                method: "POST",
                body: gemsSettingData,
            });

            const data = await response.json();

            if (data && data.data) {
                console.log(data.data);
                setAll_shape(data.data.shape);
                setTypeMarks(data.data.type);
                setTreatmentMarks(data.data.treatment);
                setClarityMarks(data.data.clarity);
                setColorsMarks(data.data.color);
                setLabMarks(data.data.lab);
                setOriginMarks(data.data.origin);

            }
        } catch (error) {
            console.error("Error fetching fancy colors:", error);
        }
    };


    const onType = (type) => {
        setType((prev) =>
            prev.includes(type) ? prev.filter((t) => t !== type) : [...prev, type]
        );
        setOrderby("type");
        resetpagination();
    };
    const onTreatment = (treatment) => {
        setTreatment(treatment);
        setOrderby("treatment");
        resetpagination();
    };
    const onClarity = (checkedValues) => {

        setClarity(checkedValues);
        setOrderby("clarity");
        resetpagination();
    };

    const onColors = (color) => {
        setColor((prev) =>
            prev.includes(color) ? prev.filter((t) => t !== color) : [...prev, color]
        );
        setOrderby("color");
        resetpagination();
    };

    const onOrigin = (origin) => {
        setOrigin(origin);
        setOrderby("origin");
        resetpagination();
    };
    const onLab = (checkedValues) => {
        setLab(checkedValues);
        setOrderby("lab_company");
        resetpagination();
    };


    //Carat
    const [isCarat, setCarat] = useState([1, 7]);
    const [minCarat, setMinCarat] = useState("1");
    const [maxCarat, setMaxCarat] = useState("7");
    const CaratMin = (value: number) => {
        setMinCarat(value);
        // filterTrigger();
    };
    const CaratMax = (value: number) => {
        setMaxCarat(value);
        // filterTrigger();
    };

    const CaratRangeChange = (value: number | [number, number]) => {
        setMinCarat(value[0]);
        setMaxCarat(value[1]);
    };

    //Width
    const [isWidth, setWidth] = useState([]);
    const [minWidth, setMinWidth] = useState("");
    const [maxWidth, setMaxWidth] = useState("");
    const WidthMin = (value: number) => {
        setMinWidth(value);
        //setWidth([value, maxWidth]);
        // filterTrigger();
    };
    const WidthMax = (value: number) => {
        setMaxWidth(value);
        //setWidth([minWidth, value]);
        // filterTrigger();
    };

    const WidthRangeChange = (value: number | [number, number]) => {

        if (Array.isArray(value) && value.length === 2) {
            const [min, max] = value;

            if ((typeof min === 'number' || typeof min === 'string') && (typeof max === 'number' || typeof max === 'string') && !isNaN(Number(min)) && !isNaN(Number(max))) {
                const minNum = Number(min);
                const maxNum = Number(max);
                console.log(minNum);
                console.log(maxNum);
                if (maxNum < minNum) {
                    toast.error("Invalid input: Max value cannot be less than Min value.");
                    return false;
                }else {
                    setMinWidth(min);
                    setMaxWidth(max);
                    setWidth([min, min]);
                }
            } else {
                toast.error("Both values must be valid numbers.");
                return false;
            }
        } else {
            toast.error("Expected an array with two numeric values.");
            return false;
        }
    };
    //Length
    const [isLength, setLength] = useState([]);
    const [minLength, setMinLength] = useState("");
    const [maxLength, setMaxLength] = useState("");
    const LengthMin = (value: number) => {
        setMinLength(value);
        //setLength([value, maxLength]);
        // filterTrigger();
    };
    const LengthMax = (value: number) => {
        setMaxLength(value);
        //setLength([minLength, value]);
        // filterTrigger();
    };

    const LengthRangeChange = (value: number | [number, number]) => {
        if (Array.isArray(value) && value.length === 2) {
            const [min, max] = value;

            if ((typeof min === 'number' || typeof min === 'string') && (typeof max === 'number' || typeof max === 'string') && !isNaN(Number(min)) && !isNaN(Number(max))) {
                const minNum = Number(min);
                const maxNum = Number(max);
                if (maxNum < minNum) {
                    toast.error("Invalid input: Max value cannot be less than Min value.");
                    return false;
                }else {
                    setMinLength(min);
                    setMaxLength(max);
                    setLength([min, min]);
                }

            } else {
                toast.error("Both values must be valid numbers.");
                return false;
            }
        } else {
            toast.error("Expected an array with two numeric values.");
            return false;
        }
    };
    //Depth
    const [isDepth, setDepth] = useState([]);
    const [minDepth, setMinDepth] = useState("");
    const [maxDepth, setMaxDepth] = useState("");
    const DepthMin = (value: number) => {
        setMinDepth(value);
        //setDepth([value, maxDepth]);
        // filterTrigger();
    };
    const DepthMax = (value: number) => {
        setMaxDepth(value);
        //setDepth([minDepth, value]);
        // filterTrigger();
    };

    const DepthRangeChange = (value: number | [number, number]) => {
        // Check if value is an array and has both numbers
        if (Array.isArray(value) && value.length === 2) {
            const [min, max] = value;
                console.log(min);
                console.log(max);
            if ((typeof min === 'number' || typeof min === 'string') && (typeof max === 'number' || typeof max === 'string') && !isNaN(Number(min)) && !isNaN(Number(max))) {
                const minNum = Number(min);
                const maxNum = Number(max);

                if (maxNum < minNum) {
                    toast.error("Invalid input: Max value cannot be less than Min value.");
                    return false;
                }else {
                    setMinDepth(min);
                    setMaxDepth(max);
                    setDepth([min, min]);
                }

            } else {
                toast.error("Both values must be valid numbers.");
                return false;
            }
        } else {
            toast.error("Expected with two numeric values.");
            return false;
        }
    };

    //Price
    const [isPrice, setPrice] = useState([200, 1000000]);
    const [minPrice, setMinPrice] = useState("200");
    const [maxPrice, setMaxPrice] = useState("1000000");
    const PriceMin = (value: number) => {
        setMinPrice(value);
        setPrice([value, maxPrice]);
        // filterTrigger();
    };
    const PriceMax = (value: number) => {
        setMaxPrice(value);
        setPrice([minPrice, value]);
        // filterTrigger();
    };

    const PriceRangeChange = (value: number | [number, number]) => {
        setMinPrice(value[0]);
        setMaxPrice(value[1]);
    };


    //Advance Option
    const [openAdvance, setOpenAdvance] = useState(false);


    //API Trigger
    const resetFilter = (e) => {
        setDiamondType("gems");
        setShape("");
        setClarity([]);
        setColor([]);
        setCarat([1, 7]);
        setMinCarat(0.01);
        setMaxCarat(7);
        setPrice(200, 1000000);
        setMinPrice(200);
        setMaxPrice(1000000);
        setLab([]);
        setOrigin([]);
        setWidth([]);
        setMinWidth('');
        setMaxWidth('');
        setLength([]);
        setMinLength('');
        setMaxLength('');
        setDepth([]);
        setMinDepth('');
        setMaxDepth('');
        resetpagination();


    };
    const filterTrigger = (e) => {
        console.log("onAfterChange: ", e);

        getProd();
    };


    /*****Filter Button mobile******/

    const mobile_filter_btn = ["Shape", "Cut", "Clarity", "Color", "Carat", "Price", "Polish", "Symmetry", "Fluorescence", "Lab", "Depth", "Table"];

    const [mobilePopup, setMobilePopup] = useState("");


    /****API Data***/
    let [jescnt, setJescnt] = useState([]);
    let [jesdada, setJesdata] = useState([]);
    let [orderby, setOrderby] = useState("total_price");
    const [perPage] = useState(20);
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [offset, setOffset] = useState(0);
    const handlePageClick = async (e) => {
        const selectedPage = e.selected;
        setCurrentPage(selectedPage);
        //  console.log(selectedPage * perPage)
        setOffset(selectedPage * perPage);
        const scroll_top = document.getElementById("filter-slide");
        if (scroll_top) {

            scroll_top.scrollIntoView({block: "start", behavior: "smooth"});
        }
    };
    const {shape} = useParams();
    const params = useParams();

    function resetpagination() {
        setCurrentPage(0);
        setOffset(0);
    }

    async function getProd() {
        props.loader(true);
        var formData = new FormData();
        var request_data = new FormData();
        var flag = 0;
        if (isShapeClicked == false) {
            if (params.shape) {
                setShape(params.shape);
            }
        }

        if (isShape) {
            flag = 1;

            request_data.shape = isShape;
        }

        if (isDiamondType.length > 0) {
            flag = 1;
            request_data.type = isDiamondType;
        }



        if (isColorType) {
            flag = 1;
            request_data.colortype = isColorType;
        }
        if (isColor.length > 0) {
            flag = 1;
            request_data.color = isColor;
        }


        if (isCarat.length > 0) {
            flag = 1;
            request_data.carat = isCarat;
        }

        if (isType.length > 0) {
            flag = 1;
            request_data.gemtype = isType;
        }
        if (isTreatment.length > 0) {
            flag = 1;
            request_data.treatment = isTreatment;
        }



        if (isWidth.length > 0) {
            flag = 1;
            request_data.width = isWidth;
        }
        if (isLength.length > 0) {
            flag = 1;
            request_data.length = isLength;
        }
        if (isDepth.length > 0) {
            flag = 1;
            request_data.depth = isDepth;
        }
        if (isClarity.length > 0) {
            flag = 1;

            request_data.clarity = isClarity;
        }

        if (isPrice.length > 0) {
            flag = 1;
            request_data.price = isPrice;
        }


        if (isLab.length > 0) {
            flag = 1;
            request_data.lab = isLab;
        }

        request_data.currency = localStorage.getItem("currency");
        request_data.offset = offset;
        request_data.orderby = orderby;

        formData.append("request", JSON.stringify(request_data));

        axios.post(process.env.REACT_APP_API_URL + "/api/getproducts", formData)
            .then(function (response) {

                setJesdata(response.data.data);
                setJescnt(response.data.count);
                setPageCount(Math.ceil(jescnt / perPage));

                setTimeout(function () {
                    props.loader(false);
                }, 1000);
            })
            .catch(function (error) {
                console.log(error);
            });


    }

    let all_diamond_tab;
    let comparison_tab;
    let recently_view_tab;
    if (window.innerWidth < 768) {
        all_diamond_tab = "All";
        //comparison_tab = "Compare";
        recently_view_tab = "Recent";
    } else {
        //all_diamond_tab =  "ALL Diamonds (" + jescnt + ")"
        all_diamond_tab = "ALL GEMSTONE";
        //comparison_tab = "Comparison";
        recently_view_tab = "Recently Viewed";
    }


    window.addEventListener("resize", function () {
        if (window.innerWidth < 768) {
            all_diamond_tab = "All";
            //all_diamond_tab = "All (" + jescnt + ")"
            //comparison_tab = "Compare";
            recently_view_tab = "Recent";
        } else {
            //all_diamond_tab =  "ALL Diamonds (" + jescnt + ")"
            all_diamond_tab = "ALL GEMSTONE";
            //comparison_tab = "Comparison";
            recently_view_tab = "Recently Viewed";
        }
    });


    const popover_cut = (
        <Popover className="filter_info">
            <Popover.Body>
                <iframe scrolling="no" width="100%" height="400" className="overflow-hidden"
                        src="https://4cs.gia.edu/interactive-4cs//standalone/cut.html"></iframe>
            </Popover.Body>
        </Popover>
    );
    const popover_clarity = (
        <Popover className="filter_info">
            <Popover.Body>
                <iframe scrolling="no" width="100%" height="400" className="overflow-hidden"
                        src="https://4cs.gia.edu/interactive-4cs//standalone/clarity.html"></iframe>
            </Popover.Body>
        </Popover>
    );

    const popover_color = (
        <Popover className="filter_info">
            <Popover.Body>
                <iframe scrolling="no" width="100%" height="400" className="overflow-hidden"
                        src="https://4cs.gia.edu/interactive-4cs//standalone/color.html"></iframe>
            </Popover.Body>
        </Popover>
    );
    const popover_carat = (
        <Popover className="filter_info">
            <Popover.Body>
                <iframe scrolling="no" width="100%" height="400" className="overflow-hidden"
                        src="https://4cs.gia.edu/interactive-4cs//standalone/carat-weight.html"></iframe>
            </Popover.Body>
        </Popover>
    );
    useEffect(() => {
        gemsSettings();
    }, []);

    useEffect(() => {
        getProd();


    }, [isDiamondType, isShape, isClarity,isColorType, isColor, isCarat,isWidth,isLength,isDepth,isOrigin,isType
        ,isTreatment,isLab, isPrice, jescnt, offset]);


    return (
        <>
            {/*Desktop Filter*/}

            <div className="container pt-3">
                <div className="row">
                    <div className="col-12">


                        <FilterStepsGems active={1}/>

                    </div>
                </div>
            </div>
            <div className="container desktop-filter">

                <div className="row">
                    <div className="col-lg-12 filter_control type_main mb-3" id="cut_data">
                        <label>Type</label>

                        <div className="shape_control_list type_control_list">
                            {TypeMarks.length > 0 && (
                                TypeMarks.map((type, index) => (
                                    <div
                                        className="shape_control_item"
                                        key={index}
                                        title={ucfirst(type.name)}
                                    >
                                        <input
                                            onChange={() => {
                                                onType(type.name);
                                                setOrderby("type");
                                                resetpagination();
                                            }}
                                            className="form-checkbox"
                                            type="checkbox"
                                            name="type[]"
                                            value={type.name}
                                            id={`filter_${type.name}`}
                                            checked={isType.includes(type.name)}
                                        />
                                        <label htmlFor={`filter_${type.name}`}>
                                            <div className="shape_item_img">
                                                <img
                                                    className="img-fluid"
                                                    src={type.icon}
                                                    alt={type.name}
                                                />
                                            </div>
                                            <div className="shape_item_label text-center">
                                                {type.name}
                                            </div>
                                        </label>
                                    </div>
                                ))
                            )}

                        </div>


                    </div>
                    <div className="col-lg-12 filter_control color_main mb-3" id="color_data">
                        <label>Color

                        </label>          <div className="shape_control_list">
                        {isColorType === 2 && ColorsMarks.length > 0 && (
                            ColorsMarks.map((color, index) => (
                                <div
                                    className="shape_control_item"
                                    key={index}
                                    title={ucfirst(color.name)}
                                >
                                    <input
                                        onChange={() => {
                                            onColors(color.name);
                                            setOrderby("color");
                                            resetpagination();
                                        }}
                                        className="form-checkbox"
                                        type="checkbox"
                                        name="color[]"
                                        value={color.name}
                                        id={`filter_${color.name}`}
                                        checked={isColor.includes(color.name)}
                                    />
                                    <label htmlFor={`filter_${color.name}`}>
                                        <div className="shape_item_img">
                                            <img
                                                className="img-fluid"
                                                src={color.icon}
                                                alt={color.name}
                                            />
                                        </div>
                                        <div className="shape_item_label text-center">
                                            {color.name}
                                        </div>
                                    </label>
                                </div>
                            ))
                        )}

                    </div>
                    </div>
                    <div className="col-lg-6 filter_control shape_main mb-3" id="shape_data">
                        <label>Shape</label>
                        <div className="shape_control_list">
                            {(all_shape.length > 0) ? all_shape.map((shape, index) => (
                                <div className="shape_control_item" key={index}  title={ucfirst(shape.name)}>
                                    {shape.name === isShape}


                                    <input onChange={(e) => {
                                        setShape(shape.name);
                                        setOrderby("shape");
                                        setShapeClicked(true);
                                        resetpagination();
                                        navigate(`/settings-gemstone/shape/${shape.name}`);
                                    }} className="form-checkbox" type="radio" name="shape" value={shape.name}
                                           id={"filter_" + shape.name} checked={(shape.name === isShape) ? true : ""}/>
                                    <label htmlFor={"filter_" + shape.name}>
                                        <div className="shape_item_img">
                                            <img className="img-fluid"
                                                 src={shape.icon}
                                                 alt={shape.name}/>
                                        </div>
                                        <div className="shape_item_label text-center">{shape.name}</div>
                                    </label>
                                </div>
                            )) : ""}

                        </div>
                      {/*  <div className="col-lg-12 text-center">
                        {all_shape.length > 10 && (
                            <button onClick={() => setShowAllShape(!showAllShape)} className="show-more-btn">
                                {showAllShape ? "Show Less" : "Show More"}
                            </button>
                        )}
                        </div>*/}
                    </div>

                    {/*<div className="col-lg-12 filter_control cut_main mb-3" id="cut_data">
                        <label>Cut</label>
                        <div className="cut_control_list">
                            <Checkbox.Group style={{width: "100%"}} onChange={onCut}>
                                <Row gutter={[8,8]}>
                                    {CutMarks.map((cut, index) => (
                                        <Col key={index}>
                                            <Checkbox value={cut} className={"fancyselection"}>{cut}</Checkbox>
                                        </Col>
                                    ))}
                                </Row>
                            </Checkbox.Group>
                        </div>
                    </div>*/}


                    <div className="col-lg-6 filter_control clarity_main mb-3" id="clarity_data">
                        <label>Clarity</label>
                        <div className="clarity_control_list">
                            <Checkbox.Group style={{width: "100%"}} onChange={onClarity}>
                                <Row gutter={[8,8]}>
                                    {ClarityMarks.map((clarity, index) => (
                                        <Col key={index}>
                                            <Checkbox value={clarity} className={"fancyselection"}>{clarity}</Checkbox>
                                        </Col>
                                    ))}
                                </Row>
                            </Checkbox.Group>
                        </div>
                    </div>


                    <div className="col-lg-6 filter_control carat_main" id="carat_data">
                        <label>Carat<OverlayTrigger rootClose trigger="click" placement="bottom"
                                                    overlay={popover_carat}>
                            <Button className="question_mark"><i className="fas fa-question-circle"></i></Button>
                        </OverlayTrigger></label>
                        <div className="carat_control_list">
                            <div className="row">
                                <div className="col-6 text-start">
                                    <InputNumber controls={true} min={0.01} step={0.01} max={7} value={minCarat}
                                                 onStep={(e) => {
                                                     setCarat([e.target.value, maxCarat]);
                                                     resetpagination();
                                                 }}
                                                 onPressEnter={(e) => {
                                                     setCarat([e.target.value, maxCarat]);
                                                     setOrderby("carat");
                                                     resetpagination();
                                                 }} onChange={CaratMin}/>

                                </div>
                                <div className="col-6 text-end">
                                    <InputNumber controls={true} min={0.01} step={0.01} max={7} value={maxCarat}
                                                 onStep={(e) => {
                                                     setCarat([minCarat, e.target.value]);
                                                     resetpagination();
                                                 }}
                                                 onPressEnter={(e) => {
                                                     setCarat([minCarat, e.target.value]);
                                                     setOrderby("carat");
                                                     resetpagination();
                                                 }} onChange={CaratMax}/>
                                </div>
                            </div>
                            <Slider range value={[minCarat, maxCarat]} step={0.01} min={0.01} max={7}
                                    tooltip={{formatter: null}} draggableTrack={true} onChange={CaratRangeChange}
                                    onAfterChange={(e: number | [number, number]) => {
                                        setCarat(e);
                                        setOrderby("carat");
                                        resetpagination();
                                    }}/>

                        </div>
                    </div>
                    <div className="col-lg-6 filter_control price_main" id="price_data">
                        <label>Price</label>
                        <div className="price_control_list">
                            <div className="row">
                                <div className="col-6 text-start">
                                    <InputNumber className="price_control_input" controls={false} min={200} step={1}
                                                 max={1000000} prefix={localStorage.getItem("currency")}
                                                 formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                 value={minPrice}
                                                 onStep={(e) => {
                                                     setPrice([e.target.value, maxPrice]);
                                                     resetpagination();
                                                 }}
                                                 onPressEnter={(e) => {
                                                     setPrice([e.target.value, maxPrice]);
                                                     setOrderby("total_price");
                                                     resetpagination();
                                                 }}
                                                 onChange={PriceMin}/>

                                </div>
                                <div className="col-6 text-end">
                                    <InputNumber className="price_control_input" controls={false} min={200} step={1}
                                                 max={1000000} prefix={localStorage.getItem("currency")}
                                                 formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                 value={maxPrice}
                                                 onStep={(e) => {
                                                     setPrice([minPrice, e.target.value]);
                                                     resetpagination();
                                                 }}
                                                 onPressEnter={(e) => {
                                                     setPrice([minPrice, e.target.value]);
                                                     setOrderby("total_price");
                                                     resetpagination();
                                                 }}
                                                 onChange={PriceMax}/>
                                </div>
                            </div>
                            <Slider range value={[minPrice, maxPrice]} step={1} min={200} max={1000000}
                                    tooltip={{formatter: null}} draggableTrack={true} onChange={PriceRangeChange}
                                    onAfterChange={(e: number | [number, number]) => {
                                        setPrice(e);
                                        setOrderby("total_price");
                                        resetpagination();
                                    }}/>

                        </div>
                    </div>
                    <div className="col-md-12 mt-3">
                        <div className="d-block align-items-center panAdvance">


                            <Collapse in={openAdvance}>
                                <div id="panAdvanceInner">
                                    <div className="row">
                                        <div className="col-lg-6 filter_control treatment_main mb-3" id="cut_data">
                                            <label>Treatment</label>
                                            <div className="cut_control_list">
                                                <Select
                                                    mode="multiple"
                                                    allowClear
                                                    style={{ width: '100%' }}
                                                    placeholder="Please select"
                                                    defaultValue={isTreatment}
                                                    onChange={onTreatment}
                                                    options={TreatmentMarks}
                                                />

                                                {/*<Checkbox.Group style={{width: "100%"}} onChange={onCut}>
                                                    <Row gutter={[8,8]}>
                                                        {TreatmentMarks.map((treatment, index) => (
                                                            <Col key={index}>
                                                                <Checkbox value={treatment} className={"fancyselection"}>{treatment}</Checkbox>
                                                            </Col>
                                                        ))}
                                                    </Row>
                                                </Checkbox.Group>*/}
                                            </div>
                                        </div>
                                        <div className="col-lg-6 filter_control treatment_main mb-3" id="origin_data">
                                            <label>Origin</label>
                                            <div className="origin_control_list">
                                                <Select
                                                    mode="multiple"
                                                    allowClear
                                                    style={{ width: '100%' }}
                                                    placeholder="Please select"
                                                    defaultValue={isOrigin}
                                                    onChange={onOrigin}
                                                    options={OriginMarks}
                                                />{/*
                                                <Checkbox.Group style={{width: "100%"}} onChange={onOrigin}>
                                                    <Row gutter={[8,8]}>
                                                        {OriginMarks.map((origin, index) => (
                                                            <Col key={index}>
                                                                <Checkbox value={origin} className={"fancyselection"}>{origin}</Checkbox>
                                                            </Col>
                                                        ))}
                                                    </Row>
                                                </Checkbox.Group>*/}
                                            </div>
                                        </div>
                                        <div className="col-lg-6 filter_control mm_main mb-3" id="mm_data">
                                            <label>MM Size</label>
                                            <div className="mm_control_list">
                                                    <div className="row mb-3">
                                                        <div className="col-12 text-start">
                                                            <label className={'fw-bold  text-black'}>Width (mm)</label>
                                                        </div>
                                                        <div className="col-6 text-start">
                                                            <InputNumber className={'w-100'} controls={true} min={0} step={0.01} max={''} value={minWidth}
                                                                         onStep={(e) => {
                                                                             WidthRangeChange([e.target.value, maxWidth]);
                                                                             resetpagination();
                                                                         }}
                                                                         placeholder={'Min'}
                                                                         onPressEnter={(e) => {
                                                                             WidthRangeChange([e.target.value, maxWidth]);
                                                                             setOrderby("measurement_width");
                                                                             resetpagination();
                                                                         }} onChange={WidthMin}/>

                                                        </div>
                                                        <div className="col-6 text-end">
                                                            <InputNumber  className={'w-100'} controls={true} min={0} step={0.01} max={''} value={maxWidth}
                                                                         onStep={(e) => {
                                                                             WidthRangeChange([minWidth, e.target.value]);
                                                                             resetpagination();
                                                                         }}
                                                                          placeholder={'Max'}
                                                                         onPressEnter={(e) => {
                                                                             WidthRangeChange([minWidth, e.target.value]);
                                                                             setOrderby("measurement_width");
                                                                             resetpagination();
                                                                         }} onChange={WidthMax}/>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3">
                                                        <div className="col-12 text-start">
                                                            <label className={'fw-bold  text-black'}>Length (mm)</label>
                                                        </div>
                                                        <div className="col-6 text-start">
                                                            <InputNumber  className={'w-100'} controls={true} min={0} step={0.01} max={''} value={minLength}
                                                                         onStep={(e) => {
                                                                             LengthRangeChange([e.target.value, maxLength]);
                                                                             resetpagination();
                                                                         }}
                                                                          placeholder={'Min'}
                                                                         onPressEnter={(e) => {
                                                                             LengthRangeChange([e.target.value, maxLength]);
                                                                             setOrderby("measurement_length");
                                                                             resetpagination();
                                                                         }} onChange={LengthMin}/>

                                                        </div>
                                                        <div className="col-6 text-end">
                                                            <InputNumber  className={'w-100'} controls={true} min={0} step={0.01} max={''} value={maxLength}
                                                                         onStep={(e) => {
                                                                             LengthRangeChange([minLength, e.target.value]);
                                                                             resetpagination();
                                                                         }}
                                                                          placeholder={'Max'}
                                                                         onPressEnter={(e) => {
                                                                             LengthRangeChange([minLength, e.target.value]);
                                                                             setOrderby("measurement_length");
                                                                             resetpagination();
                                                                         }} onChange={LengthMax}/>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3">
                                                        <div className="col-12 text-start">
                                                            <label className={'fw-bold  text-black'}>Depth (mm)</label>
                                                        </div>
                                                        <div className="col-6 text-start">
                                                            <InputNumber  className={'w-100'} controls={true} min={0} step={0.01} max={''} value={minDepth}
                                                                         onStep={(e) => {
                                                                             DepthRangeChange([e.target.value, maxDepth]);
                                                                             resetpagination();
                                                                         }}
                                                                         onPressEnter={(e) => {
                                                                             DepthRangeChange([e.target.value, maxDepth]);
                                                                             setOrderby("measurement_height");
                                                                             resetpagination();
                                                                         }}
                                                                          placeholder={'Min'}

                                                                          onChange={DepthMin}/>

                                                        </div>
                                                        <div className="col-6 text-end">
                                                            <InputNumber  className={'w-100'} controls={true} min={0} step={0.01} max={''} value={maxDepth}
                                                                         onStep={(e) => {
                                                                             DepthRangeChange([minDepth, e.target.value]);
                                                                             resetpagination();
                                                                         }}
                                                                          placeholder={'Max'}
                                                                         onPressEnter={(e) => {
                                                                             DepthRangeChange([minDepth, e.target.value]);
                                                                             setOrderby("measurement_height");
                                                                             resetpagination();
                                                                         }} onChange={DepthMax}/>
                                                        </div>
                                                    </div>


                                            </div>
                                        </div>
                                        <div className="col-lg-6 filter_control treatment_main mb-3" id="lab_data">
                                            <label>Lab</label>
                                            <div className="origin_control_list">
                                                <Checkbox.Group
                                                    style={{ width: "100%" }}
                                                    onChange={onLab}
                                                    value={isLab} // Ensure this holds an array like ['GIA', 'AGS']
                                                >
                                                    <Row gutter={[8, 8]}>
                                                        {LabMarks.map((lab, index) => (
                                                            <Col key={index}>
                                                                <Checkbox value={lab} className="fancyselection">
                                                                    {lab}
                                                                </Checkbox>
                                                            </Col>
                                                        ))}
                                                    </Row>
                                                </Checkbox.Group>

                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </Collapse>


                            <div className="row">
                                <div className="col-6 text-start">
                                    <button
                                        onClick={resetFilter}
                                        className=" btn btn-dark btnReset mt-3 rounded-0 text-uppercase"> Reset Filters
                                    </button>
                                </div>
                                <div className="col-6 text-end">
                                    <button
                                        onClick={() => setOpenAdvance(!openAdvance)}
                                        className="btn btn-primary btnAdvance rounded-0 mt-3">
                                        Advanced Options {openAdvance ?
                                        <i className="fas fa-angle-double-up ms-2"></i> :
                                        <i className="fas fa-angle-double-down ms-2"></i>}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
            {/*Mobile Filter*/}



            {/*Layout*/}
            <div className="container position-relative">
                <div className="row">
                    <div className="col-md-12 fltrPlod-list position-relative">
                        <Tabs
                            defaultActiveKey="all"
                            id="settings-diamond-tabs"
                            className="mb-3"
                            mountOnEnter unmountOnExit
                        >
                            <Tab eventKey="all" title={all_diamond_tab}>

                                <Tabs mountOnEnter unmountOnExit defaultActiveKey="grid"
                                      id="diamond-tabs"
                                      className="grid-list-btn float-end mb-3 nav nav-tabs position-absolute  top-0">

                                    <Tab eventKey="list" className="position-relative" title={(<FaThList/>)}>

                                        <div className="table-responsive">

                                            <table className="table diamond-list-table">
                                                <thead>
                                                <tr>
                                                    <th>Actual Photo</th>
                                                    <th>Shape</th>
                                                    <th>Carat</th>
                                                    <th>Color</th>
                                                    <th>Clarity</th>
                                                    <th>Cut</th>
                                                    <th>Lab</th>

                                                </tr>
                                                </thead>
                                                <tbody>
                                                {jesdada && jesdada.map((jd) => (


                                                    <ProductItemList key={jd.id} loader={props.loader}
                                                                     type={isDiamondType} product_id={jd.stone_id}/>


                                                ))}
                                                </tbody>

                                            </table>
                                            <div className="col-12 mt-5">
                                                <nav className="d-flex justify-content-center">
                                                    <ReactPaginate previousLabel={"←"} nextLabel={"→"}
                                                                   breakLabel={"..."} breakClassName={"break-me"}
                                                                   pageCount={pageCount} marginPagesDisplayed={2}
                                                                   pageRangeDisplayed={5}
                                                                   onPageChange={handlePageClick}
                                                                   forcePage={currentPage}
                                                                   containerClassName={""}

                                                                   pageClassName={"page-item"}
                                                                   pageLinkClassName={"page-link"}
                                                                   className={"pagination"}
                                                                   previousClassName={"page-item prev-page"}
                                                                   nextClassName={"page-item next-page"}
                                                                   subContainerClassName={"pages pagination"}
                                                                   activeClassName={"active"}
                                                                   activeLinkClassName={"active"}
                                                                   previousLinkClassName={"page-link"}
                                                                   nextLinkClassName={"page-link"}/>
                                                </nav>
                                            </div>
                                        </div>
                                    </Tab>
                                    <Tab eventKey="grid" title={(<FaTh/>)}>
                                        <div className="row position-relative">

                                            {(jesdada.length > 0) ? jesdada.map((jd) => (


                                                <ProductItem loader={props.loader} buttons={true} type={isDiamondType}
                                                             class=" col-12 col-sm-6 col-md-6 col-lg-3 mb-3 position-relative"
                                                             key={jd.id} product_id={jd.stone_id}/>


                                            )) : (
                                                <>
                                                    <div className="col-md-12 compare-page">
                                                        <div className="entry-content text-black text-center">
                                                            <div><i
                                                                className="display-2 fa-regular fa-rings-wedding opacity-25 text-muted"></i>
                                                                <h3 className="display-5"> We are sorry !</h3>
                                                                <div className="empty-page-text text-muted">
                                                                    Do drop us a message and let us source the diamond
                                                                    for you.
                                                                </div>
                                                                <p className="return-to-shop"><a
                                                                    className="btn btn-primary" href="/contact-us"> GET
                                                                    IN TOUCH WITH US</a></p></div>
                                                        </div>
                                                    </div>
                                                </>
                                            )}


                                            <div className="col-12 mt-5">
                                                <nav className="d-flex justify-content-center">
                                                    <ReactPaginate previousLabel={"←"} nextLabel={"→"}
                                                                   breakLabel={"..."} breakClassName={"break-me"}
                                                                   pageCount={pageCount} marginPagesDisplayed={2}
                                                                   pageRangeDisplayed={4}
                                                                   onPageChange={handlePageClick}
                                                                   forcePage={currentPage}
                                                                   containerClassName={""}
                                                                   pageClassName={"page-item"}
                                                                   pageLinkClassName={"page-link"}
                                                                   className={"pagination"}
                                                                   previousClassName={"page-item prev-page"}
                                                                   nextClassName={"page-item next-page"}
                                                                   subContainerClassName={"pages pagination"}
                                                                   activeClassName={"active"}
                                                                   activeLinkClassName={"active"}
                                                                   previousLinkClassName={"page-link"}
                                                                   nextLinkClassName={"page-link"}/>
                                                </nav>
                                            </div>
                                        </div>
                                    </Tab>
                                </Tabs>
                            </Tab>
                            <Tab eventKey="recent_view" title={recently_view_tab}>
                                <div className="row itemList-cont g-2">
                                    <RecentProducts loader={props.loader} type="diamond"/>
                                </div>
                            </Tab>
                        </Tabs>

                    </div>
                </div>
            </div>
        </>
    );
}

export default GemstoneSetting;
